import GastStationMarker from "./icons/markers/gastations.png";
import CarWashingMarker from "./icons/markers/carwashing.png";
import SalesMarker from "./icons/markers/sales.png";
import ParkingMarker from "./icons/markers/parking.png";
import TollMarker from "./icons/markers/toll.png";
import ParkingMetersMarker from "./icons/markers/parkingmeters.png";

import GastStationFill from "./icons/fill/gasstation_fill_orange.png";
import CarWashingFill from "./icons/fill/carwashing_fill_purple.png";
import SalesFill from "./icons/fill/sales_fill_green.png";
import ParkingFill from "./icons/fill/parking_fill_blue.png";
import TollFill from "./icons/fill/toll_fill_yellow.png";
import ParkingMetersFill from "./icons/fill/parkingmeters_fill_blue.png";

import GastStation from "./icons/gasstation_orange.png";
import CarWashing from "./icons/carwashing_purple.png";
import Sales from "./icons/sales_green.png";
import Parking from "./icons/parking_blue.png";
import Toll from "./icons/toll_yellow.png";
import ParkingMeters from "./icons/parkingmeters_blue.png";

import TollDisabled from "./icons/disabled/toll_disabled.png";
import ParkingDisabled  from "./icons/disabled/parking_disabled.png";
import ParkingMetersDisabled  from "./icons/disabled/parkingmeters_disabled.png";
import GastStationDisabled from "./icons/disabled/gasstation_disabled.png";
import CarWashingDisabled from "./icons/disabled/carwashing_disabled.png";
import SalesDisabled from "./icons/disabled/sales_disabled.png";

export const ICONS = new Map([
  [
    "toll",
    {
      marker: `url(${TollMarker})`,
      fill: `${TollFill}`,
      button: `${Toll}`,
      disable: `${TollDisabled}`,
    },
  ],
  [
    "parking",
    {
      marker: `url(${ParkingMarker})`,
      fill: `${ParkingFill}`,
      button: `${Parking}`,
      disable: `${ParkingDisabled}`,
    },
  ],
  [
    "parkingmeters",
    {
      marker: `url(${ParkingMetersMarker})`,
      fill: `${ParkingMetersFill}`,
      button: `${ParkingMeters}`,
      disable: `${ParkingMetersDisabled}`,
    },
  ],
  [
    "gasstations",
    {
      marker: `url(${GastStationMarker})`,
      fill: `${GastStationFill}`,
      button: `${GastStation}`,
      disable: `${GastStationDisabled}`,
    },
  ],
  [
    "carwashing",
    {
      marker: `url(${CarWashingMarker})`,
      fill: `${CarWashingFill}`,
      button: `${CarWashing}`,
      disable: `${CarWashingDisabled}`,
    },
  ],
  [
    "sales",
    {
      marker: `url(${SalesMarker})`,
      fill: `${SalesFill}`,
      button: `${Sales}`,
      disable: `${SalesDisabled}`,
    },
  ],
]);
